'use client';

import Link from 'next/link';
import { useQuery } from '@tanstack/react-query';
import { ArrowUpRight } from '@phosphor-icons/react';
import { blogApi } from '@/lib/api/blog';
import { BlogCard, BlogGridSkeleton } from './blog-editorial';
import './blog-editorial.css';

export function BlogSection() {
  const { data, isLoading } = useQuery({
    queryKey: ['blog-home'],
    queryFn: () => blogApi.getList(1, 3),
    staleTime: 120000,
  });
  const posts = data?.data || [];
  if (!isLoading && !posts.length) return null;

  return (
    <section className="blog-editorial journal-home" aria-labelledby="journal-home-heading">
      <div className="journal-container">
        <header className="journal-home-intro">
          <div>
            <h2 id="journal-home-heading">Блог Азиаточки</h2>
            <p className="journal-home-description">Новое в меню и истории команды.</p>
          </div>
          <Link className="journal-text-link" href="/blog">
            Все статьи <ArrowUpRight size={20} aria-hidden="true" />
          </Link>
        </header>
        {isLoading ? (
          <BlogGridSkeleton count={3} />
        ) : (
          <div className="journal-grid journal-home-grid">
            {posts.map((post) => (
              <BlogCard key={post.id} post={post} heading="h3" />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
